<i18n src="@/locales/models/organization_certification.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/agro_exporter/certifications/providers/new_organization_certification.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_organization')"
    :params="{
      agro_exporter_id: agro_exporter_id,
      organization_id: organization_id
    }"
  />

  <bread-crumbs :labels="[module_name, organization?.name]"></bread-crumbs>

  <alert-danger :errors_data="std_err" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.organization_certification.certification_id") }}
              </label>
              <div class="mt-1">
                <select-form
                  v-if="certifications.length > 0"
                  :options="certifications"
                  v-model="certification_id"
                  :class="isInvalidSelect('certification')"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label
                :class="['label-form', isInvalidLabel('certification_code')]"
              >
                {{ $t("model.organization_certification.certification_code") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="certification_code"
                  :class="['input-text', isInvalid('certification_code')]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.organization_certification.renewal_date") }}
              </label>
              <div class="mt-1">
                <date-form v-model="renewal_date" />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.organization_certification.expiration_date") }}
              </label>
              <div class="mt-1">
                <date-form
                  v-model="expiration_date"
                  :class="isInvalid('certification_code')"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.organization_certification.certificate_file") }}
              </label>
              <div class="mt-1">
                <input
                  type="file"
                  class="input-text border p-1"
                  accept=".doc, .docx, .pdf, image/*"
                  @change="setFile($event.target.files[0])"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <div class="mt-1">
                <switch-form
                  v-model="active"
                  :label="$t('model.organization_certification.active')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToShowOrganization()"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="create()"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/certifications/providers/manage_organization_certification.js";

export default {
  name: "NewOrganizationCertification",
  components: {},
  data() {
    return {
      load_general_data: false,
      organization: {},
      proc_save_button: false,
      certifications: [],
      certification_id: null,
      certification_code: null,
      expiration_date: null,
      renewal_date: null,
      active: false,
      certificate_file: null
    };
  },
  props: {
    agro_exporter_id: {},
    organization_id: {}
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      await this.fetchOrganization();
      await this.fetchCertifications();
      this.load_general_data = true;
    },
    fetchOrganization: async function () {
      let response = await Requester.fetchOrganization(
        this.agro_exporter_id,
        this.organization_id
      );

      this.organization = response.data;
      if (!this.organization.manage_certifications) this.goToShowOrganization();
    },
    fetchCertifications: async function () {
      let response = await Requester.fetchCertifications(
        this.agro_exporter_id,
        this.organization_id
      );

      this.certifications = response.data;
    },
    setFile: function (new_file) {
      this.certificate_file = new_file;
    },
    create: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.create(
          this.agro_exporter_id,
          this.organization_id,
          {
            certification_id: this.certification_id,
            certification_code: this.certification_code,
            expiration_date: this.expiration_date,
            renewal_date: this.renewal_date || "",
            active: this.active,
            certificate_file: this.certificate_file
          }
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowOrganization();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_save_button = false;
    },
    goToShowOrganization() {
      this.$router.push({
        name: this.routeName("show_organization"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          organization_id: this.organization_id
        }
      });
    }
  }
};
</script>
